export function sendData(name, params = {}) {
    const datalayer = getwebCallbackDatalayer();
    const event = {
        event: name,
        attributes: params
    }
    datalayer.push(event);
}

export function getwebCallbackDatalayer() {
	window.webCallbackDatalayer = window.webCallbackDatalayer || [];
	return window.webCallbackDatalayer;
}
